<template>
  <b-tabs v-model="activetab">
    <b-tab title="Details">
      <Create @next="nextHandler" />
    </b-tab>
    <b-tab
      title="Branches"
      :disabled="!businessCreated"
    >
      <BusinessBranchesList
        v-if="activatedBusinessId"
        :business-id="activatedBusinessId"
      />
    </b-tab>
    <b-tab
      title="Documents"
      :disabled="!businessCreated"
    >
      <documents
        v-if="activatedBusinessId"
        :business-id="activatedBusinessId"
      />
    </b-tab>
    <b-tab
      title="Billing Information"
      :disabled="!businessCreated"
    >
      <billing
        v-if="activatedBusinessId"
        :business-id="activatedBusinessId"
      />
    </b-tab>
  </b-tabs>
</template>

<script>
import { BTabs, BTab } from 'bootstrap-vue'
import { ref } from '@vue/composition-api'
import Create from '../components/create-business/Create.vue'
// import Branches from '../components/create-business/branches.vue'
import Documents from '../components/create-business/documents.vue'
import Billing from '../components/create-business/billing.vue'
import BusinessBranchesList from '../components/BusinessBranchesList.vue'
import useRegisterStoreModule from '@/hooks/useRegisterStoreModule'
import businessStore from '../store'

export default {
  components: {
    Create, BTabs, BTab, BusinessBranchesList, Documents, Billing,
  },

  setup() {
    useRegisterStoreModule('business', businessStore)

    const activetab = ref(0)
    const businessCreated = ref(false)
    const activatedBusinessId = ref(undefined)

    const nextHandler = businessId => {
      activatedBusinessId.value = businessId
      businessCreated.value = true
      setTimeout(() => {
        activetab.value += 1
      }, 0)
    }

    return {
      businessCreated,
      activetab,
      nextHandler,
      activatedBusinessId,
    }
  },
}
</script>

<style>

</style>
